function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { pvId as t } from "@payment/link-monitor";

function e(t, n) {
  return (e = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, n);
}

function n() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function r(t, i, o) {
  return (r = n() ? Reflect.construct : function (t, n, r) {
    var i = [null];
    i.push.apply(i, n);
    var o = new (Function.bind.apply(t, i))();
    return r && e(o, r.prototype), o;
  }).apply(null, arguments);
}

function i(t, e, n, r, i, o, a) {
  try {
    var c = t[o](a),
        s = c.value;
  } catch (t) {
    return void n(t);
  }

  c.done ? e(s) : Promise.resolve(s).then(r, i);
}

function o(t) {
  return function () {
    var e = this,
        n = arguments;
    return new Promise(function (r, o) {
      var a = t.apply(e, n);

      function c(t) {
        i(a, r, o, c, s, "next", t);
      }

      function s(t) {
        i(a, r, o, c, s, "throw", t);
      }

      c(void 0);
    });
  };
}

function a(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function c(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function s(t, e, n) {
  return e && c(t.prototype, e), n && c(t, n), t;
}

function u(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

var l,
    p,
    d,
    h = (function (t) {
  var e = function (t) {
    var e,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        c = i.toStringTag || "@@toStringTag";

    function s(t, e, n) {
      return Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      s({}, "");
    } catch (t) {
      s = function s(t, e, n) {
        return t[e] = n;
      };
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof g ? e : g,
          o = Object.create(i.prototype),
          a = new k(r || []);
      return o._invoke = function (t, e, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return T();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var c = x(a, n);

              if (c) {
                if (c === y) continue;
                return c;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var s = l(t, e, n);

            if ("normal" === s.type) {
              if (r = n.done ? f : d, s.arg === y) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }

            "throw" === s.type && (r = f, n.method = "throw", n.arg = s.arg);
          }
        };
      }(t, n, a), o;
    }

    function l(t, e, n) {
      try {
        return {
          type: "normal",
          arg: t.call(e, n)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        y = {};

    function g() {}

    function v() {}

    function m() {}

    var M = {};

    M[o] = function () {
      return this;
    };

    var N = Object.getPrototypeOf,
        I = N && N(N(A([])));
    I && I !== n && r.call(I, o) && (M = I);
    var w = m.prototype = g.prototype = Object.create(M);

    function b(t) {
      ["next", "throw", "return"].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function D(t, e) {
      function n(i, o, a, c) {
        var s = l(t[i], t, o);

        if ("throw" !== s.type) {
          var u = s.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? e.resolve(p.__await).then(function (t) {
            n("next", t, a, c);
          }, function (t) {
            n("throw", t, a, c);
          }) : e.resolve(p).then(function (t) {
            u.value = t, a(u);
          }, function (t) {
            return n("throw", t, a, c);
          });
        }

        c(s.arg);
      }

      var i;

      this._invoke = function (t, r) {
        function o() {
          return new e(function (e, i) {
            n(t, r, e, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function x(t, n) {
      var r = t.iterator[n.method];

      if (r === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator["return"] && (n.method = "return", n.arg = e, x(t, n), "throw" === n.method)) return y;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return y;
      }

      var i = l(r, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
    }

    function j(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function O(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function k(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(j, this), this.reset(!0);
    }

    function A(t) {
      if (t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < t.length;) {
              if (r.call(t, i)) return n.value = t[i], n.done = !1, n;
            }

            return n.value = e, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: T
      };
    }

    function T() {
      return {
        value: e,
        done: !0
      };
    }

    return v.prototype = w.constructor = m, m.constructor = v, v.displayName = s(m, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, s(t, c, "GeneratorFunction")), t.prototype = Object.create(w), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, b(D.prototype), D.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = D, t.async = function (e, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new D(u(e, n, r, i), o);
      return t.isGeneratorFunction(n) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, b(w), s(w, c, "Generator"), w[o] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e.reverse(), function n() {
        for (; e.length;) {
          var r = e.pop();
          if (r in t) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, t.values = A, k.prototype = {
      constructor: k,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;

        function i(r, i) {
          return c.type = "throw", c.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              c = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (s && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (s) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), y;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];

          if (n.tryLoc === t) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: A(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), y;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
}(l = {
  exports: {}
}, l.exports), l.exports);

function f(t, e) {
  if (null == t) return {};

  var n,
      r,
      i = function (t, e) {
    if (null == t) return {};
    var n,
        r,
        i = {},
        o = Object.keys(t);

    for (r = 0; r < o.length; r++) {
      n = o[r], e.indexOf(n) >= 0 || (i[n] = t[n]);
    }

    return i;
  }(t, e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);

    for (r = 0; r < o.length; r++) {
      n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
    }
  }

  return i;
}

function y(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function g(t) {
  return function (t) {
    if (Array.isArray(t)) return y(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || function (t, e) {
    if (t) {
      if ("string" == typeof t) return y(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(t, e) : void 0;
    }
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function v(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

function m(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function M(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function N(t, e, n) {
  return e && M(t.prototype, e), n && M(t, n), t;
}

function I(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function w(t) {
  return (w = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function b(t, e, n) {
  return (b = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
    var r = function (t, e) {
      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = w(t));) {
        ;
      }

      return t;
    }(t, e);

    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, e);
      return i.get ? i.get.call(n) : i.value;
    }
  })(t, e, n || t);
}

function D(t, e) {
  return (D = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function x(t) {
  return (x = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(t);
}

function j(t, e) {
  return !e || "object" !== x(e) && "function" != typeof e ? I(t) : e;
}

!function (t) {
  t.CreditCard = "CreditCard", t.FPX = "FPX", t.PaynowQrCode = "PaynowQrCode", t.AlipayQrCode = "AlipayQrCode", t.AlipayWap = "AlipayWap", t.Paypal = "Paypal", t.BankTransfer = "BankTransfer";
}(p || (p = {})), function (t) {
  t.Oceanpay = "Oceanpay", t.Xendit = "Xendit";
}(d || (d = {}));
var O = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    k = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    A = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    T = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function E(t) {
  return (t && t.message || "No error message").split("\n").filter(function (t) {
    return !!t;
  })[0];
}

function z(t) {
  try {
    var e = function (t) {
      if (!t.stack) return null;

      for (var e, n, r = [], i = t.stack.split("\n"), o = 0; o < i.length; ++o) {
        if (e = O.exec(i[o])) n = {
          filename: e[2] && 0 === e[2].indexOf("address at ") ? e[2].substr("address at ".length) : e[2],
          "function": e[1] || "?",
          lineno: e[3] ? +e[3] : null,
          colno: e[4] ? +e[4] : null
        };else if (e = A.exec(i[o])) n = {
          filename: e[2],
          "function": e[1] || "?",
          lineno: +e[3],
          colno: e[4] ? +e[4] : null
        };else {
          if (!(e = k.exec(i[o]))) continue;
          0 !== o || e[5] || void 0 === t.columnNumber || (r[0].column = t.columnNumber + 1), n = {
            filename: e[3],
            "function": e[1] || "?",
            lineno: e[4] ? +e[4] : null,
            colno: e[5] ? +e[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: E(t),
        type: t.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(t);

    if (e) return e;
  } catch (t) {}

  return {
    value: E(t),
    type: t && t.name,
    stacktrace: {
      frames: []
    }
  };
}

var S = Object.assign || function (t) {
  for (var e = arguments.length, n = 1; n < e; n++) {
    var r = arguments[n];

    for (var i in r) {
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
  }

  return t;
},
    C = function () {
  function t(e) {
    if (m(this, t), e.dsn) {
      var n = T.exec(e.dsn),
          r = n ? n.slice(1) : [],
          i = r[5].split("/"),
          o = i.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (o ? "/" + o : "") + "/api/" + i.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = e.environment;
  }

  return N(t, [{
    key: "prepare",
    value: function value(t) {
      return S(this.getRequestBlank(), {
        exception: {
          values: [z(t)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(t) {
      this.send(this.prepare(t));
    }
  }, {
    key: "send",
    value: function value(t) {
      if (this.apiUrl) {
        var e = new XMLHttpRequest();
        e.open("POST", this.apiUrl, !0), e.setRequestHeader("Content-type", "application/json"), e.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), e.send(JSON.stringify(t));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), t;
}();

function L(t, e) {
  return "[object RegExp]" === Object.prototype.toString.call(e) ? e.test(t) : "string" == typeof e && -1 !== t.indexOf(e);
}

var U = function (t) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && D(t, e);
  }(n, C);

  var e = function (t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = w(t);

      if (e) {
        var i = w(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);

      return j(this, n);
    };
  }(n);

  function n(t) {
    var r;
    m(this, n), (r = e.call(this, t)).options = t, r.destroyed = !1, r._state = {};
    var i = r.options || {},
        o = i.plugins,
        a = void 0 === o ? [] : o,
        c = i.beforeSend,
        s = void 0 === c ? function (t) {
      return t;
    } : c,
        u = i.beforeBreadcrumb,
        l = void 0 === u ? function (t) {
      return t;
    } : u,
        p = i.blacklistUrls,
        d = void 0 === p ? [] : p,
        h = i.ignoreErrors,
        f = void 0 === h ? [] : h,
        y = i.release,
        g = void 0 === y ? void 0 : y;
    return r.plugins = a.map(function (t) {
      return new t(I(r));
    }), r.beforeSend = s, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = f, r.release = g, r;
  }

  return N(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(t) {
      return this.setKeyState("tags", Object.assign({}, t)), this;
    }
  }, {
    key: "setTag",
    value: function value(t, e) {
      return this.extendState({
        tags: v({}, t, e)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(t, e) {
      return this.extendState({
        extra: v({}, t, e)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(t) {
      return this.setKeyState("extra", Object.assign({}, t)), this;
    }
  }, {
    key: "setUser",
    value: function value(t) {
      return this.setKeyState("user", Object.assign({}, t)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var t = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return t.extendState(this.state), t;
    }
  }, {
    key: "withScope",
    value: function value(t) {
      var e = this.clone();
      t(e), e.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(t) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(t))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(t) {
      this.setKeyState("breadcrumbs", t);
    }
  }, {
    key: "captureMessage",
    value: function value(t, e) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: t,
        level: e
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (t) {
        t.destroy && t.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(t) {
      var e = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(t).some(function (t) {
        return e.ignoreErrors.some(function (e) {
          return L(t, e);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, b(w(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(t) {
      this.destroyed || this.isDeniedUrl(t) || this.isIgnoredError(t) || (b(w(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, t))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(t) {
      if (t.message) return [t.message];
      if (t.exception) try {
        var e = t.exception.values && t.exception.values[0] || {},
            n = e.type,
            r = void 0 === n ? "" : n,
            i = e.value,
            o = void 0 === i ? "" : i;
        return ["".concat(o), "".concat(r, ": ").concat(o)];
      } catch (t) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(t) {
      if (!this.blacklistUrls.length) return !1;
      var e = this.getEventFilterUrl(t);
      return !!e && this.blacklistUrls.some(function (t) {
        return L(e, t);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(t) {
      try {
        if (t.exception) {
          var e = t.exception.values && t.exception.values[0].stacktrace && t.exception.values[0].stacktrace.frames;
          return e && e[e.length - 1].filename || null;
        }

        return null;
      } catch (t) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(t) {
      var e = this;
      this._state = Object.keys(t).reduce(function (n, r) {
        var i = e.state[r],
            o = Array.isArray(i) ? i : null,
            a = t[r],
            c = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), v({}, r, o || c ? [].concat(g(o || []), g(c || [])) : Object.assign(Object.assign({}, "string" != typeof i ? i : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(t, e) {
      this._state[t] = e;
    }
  }]), n;
}();

function P(t, e, n) {
  var r = t[e],
      i = n(r);
  if ("function" == typeof i) try {
    i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (t) {}
  t[e] = i;
}

function Q(t) {
  if (!t) return {};
  var e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e) return {};
  var n = e[6] || "",
      r = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    relative: e[5] + n + r
  };
}

function R() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && t[0] instanceof Request && t[0].method ? String(t[0].method).toUpperCase() : t[1] && t[1].method ? String(t[1].method).toUpperCase() : "GET";
}

function Y() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof t[0] ? t[0] : "Request" in window && t[0] instanceof Request ? t[0].url : String(t[0]);
}

function B(t) {
  return t && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}

function _(t) {
  var e = t,
      n = [];
  if (!e || !e.tagName) return "";
  n.push(e.tagName.toLowerCase()), e.id && n.push("#".concat(e.id));
  var r = e.className;

  if (r && "string" == typeof r) {
    var i = r.split(/\s+/);
    n.concat(i.map(function (t) {
      return ".".concat(t);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (t) {
    var r = e.getAttribute(t);
    r && n.push("[".concat(t, '="').concat(r, '"]'));
  }), n.join("");
}

function F(t) {
  try {
    for (var e, n = t, r = [], i = 0, o = 0, a = " > ".length; n && i++ < 5 && !("html" === (e = _(n)) || i > 1 && o + r.length * a + e.length >= 80);) {
      r.push(e), o += e.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (t) {
    return "<unknown>";
  }
}

function W(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(t) ? t.map(function (t) {
    try {
      return String(t);
    } catch (t) {
      return "";
    }
  }).filter(function (t) {
    return "" !== t;
  }).join(e) : "";
}

function G() {
  return "1.6.0";
}

!function () {
  function t(e) {
    m(this, t), this.client = e, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }

  N(t, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var t = this,
            e = XMLHttpRequest.prototype;
        P(e, "open", function (e) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            var o = this,
                a = r[1];
            o.__sentry_xhr__ = {
              method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
              url: r[1]
            }, "string" == typeof a && "POST" === o.__sentry_xhr__.method && a.match(/sentry_key/) && (o.__sentry_own_request__ = !0);

            var c = function c() {
              if (4 === o.readyState) {
                try {
                  o.__sentry_xhr__ && (o.__sentry_xhr__.status_code = o.status);
                } catch (t) {}

                t.xhrBreadcrumb({
                  args: r,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: o
                });
              }
            };

            return "onreadystatechange" in o && "function" == typeof o.onreadystatechange ? P(o, "onreadystatechange", function (t) {
              return function () {
                c();

                for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
                  n[r] = arguments[r];
                }

                t.apply(o, n);
              };
            }) : o.addEventListener("readystatechange", c), e.apply(o, r);
          };
        }), P(e, "send", function (e) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            return t.xhrBreadcrumb({
              args: r,
              startTimestamp: Date.now(),
              xhr: this
            }), e.apply(this, r);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var t = this,
          e = window.onpopstate;

      function n(e) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = r.length > 2 ? r[2] : void 0;

          if (o) {
            var a = t.lastHref,
                c = String(o);
            t.lastHref = c, t.historyBreadcrumb({
              from: a,
              to: c
            });
          }

          return e.apply(this, r);
        };
      }

      window.onpopstate = function () {
        var n = window.location.href,
            r = t.lastHref;

        if (t.lastHref = n, t.historyBreadcrumb({
          from: r,
          to: n
        }), e) {
          for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) {
            o[a] = arguments[a];
          }

          return e.apply(this, o);
        }
      }, P(window.history, "pushState", n), P(window.history, "replaceState", n);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (t) {
        return t();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var t = this,
          e = function e(_e) {
        return t.prepareDomEvent("click", _e);
      },
          n = function n(e) {
        return t.prepareDomEvent("keypress", e);
      };

      window.document.addEventListener("click", e, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", e, !1), window.document.removeEventListener("keypress", n, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(t, e) {
      var n;

      try {
        n = e.target ? F(e.target) : F(e);
      } catch (t) {
        n = "<unknown>";
      }

      0 !== n.length && this.client.addBreadcrumb({
        category: "ui.".concat(t),
        message: n
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var t = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;

          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (t) {
            return !1;
          }
        }()) return !1;
        if (B(window.fetch)) return !0;
        var t = !1,
            e = window.document;
        if (e && "function" == typeof e.createElement) try {
          var n = e.createElement("iframe");
          n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, e.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (t = B(n.contentWindow.fetch)), e.head.removeChild(n);
        } catch (t) {}
        return t;
      })() && P(window, "fetch", function (e) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = {
            args: r,
            fetchData: {
              method: R(r),
              url: Y(r)
            },
            startTimestamp: Date.now()
          };
          return t.fetchBreadcrumb(Object.assign({}, o)), e.apply(window, r).then(function (e) {
            return t.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              response: e
            })), e;
          }, function (e) {
            throw t.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              error: e
            })), e;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(t) {
      t.endTimestamp && (t.fetchData.url.match(/sentry_key/) && "POST" === t.fetchData.method || (t.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: t.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, t.fetchData), {
          status_code: t.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(t) {
      if (t.endTimestamp) {
        if (t.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: t.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var t = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (e) {
        e in window.console && P(window.console, e, function (n) {
          return function () {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
              i[o] = arguments[o];
            }

            var a = {
              category: "console",
              data: {
                arguments: i.map(function (t) {
                  try {
                    return JSON.stringify(t), t;
                  } catch (e) {
                    return Object.prototype.toString.call(t);
                  }
                }),
                logger: "console"
              },
              level: e,
              message: W(i, " ")
            };

            if ("assert" === e) {
              if (!1 !== i[0]) return;
              a.message = "Assertion failed: ".concat(W(i.slice(1), " ") || "console.assert"), a.data.arguments = i.slice(1);
            }

            t.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, i);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(t) {
      var e = t.from,
          n = t.to,
          r = Q(window.location.href),
          i = Q(e),
          o = Q(n);
      i.path || (i = r), r.protocol === o.protocol && r.host === o.host && (n = o.relative), r.protocol === i.protocol && r.host === i.host && (e = i.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: e,
          to: n
        }
      });
    }
  }]);
}();
var H = new U({
  dsn: "https://7de58d90007b4eb2818b8982ff3381ce@payment-sentry.duowan.com/3",
  release: "1.6.0",
  environment: "production",
  beforeSend: function beforeSend(t) {
    return t.request.url = window.location.pathname, t;
  }
});
H.setTag("pvId", t);
var V = ["body"];

function Z(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function q(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Z(Object(n), !0).forEach(function (e) {
      u(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Z(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var K,
    J = new (function () {
  function t() {
    var e = this;
    a(this, t), u(this, "options", {}), u(this, "mockReturnValue", function (t) {
      e.mockValue = t;
    }), u(this, "serialize", function (t) {
      var e = Object.prototype.toString.call(t);
      return t && "[object Object]" === e ? Object.keys(t).map(function (e) {
        return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
      }).join("&") : "";
    });
  }

  return s(t, [{
    key: "create",
    value: function value(t) {
      this.options = t;
    }
  }, {
    key: "get",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.mockValue ? this.mockValue : (t = this.buildUrl(t, e.params), this.http(t, q(q({
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8"
        },
        method: "GET"
      }, this.options), e)));
    }
  }, {
    key: "post",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (this.mockValue) return this.mockValue;
      var r = {
        Accept: "application/json"
      },
          i = e || n.data;
      return "form" === n.requestType ? (r["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", i = this.serialize(i)) : (r["Content-Type"] = "application/json;charset=UTF-8", i = i ? JSON.stringify(i) : null), this.http(t, q(q({
        headers: r,
        method: "POST",
        body: i
      }, this.options), n));
    }
  }, {
    key: "http",
    value: function value(t, e) {
      var n = this;
      return new Promise(function (r, i) {
        var o = new XMLHttpRequest(),
            a = !1,
            c = e.body,
            s = f(e, V),
            u = n.options.baseUrl && !/^(https?\:)?(\/\/)/.test(t) ? "".concat(n.options.baseUrl).concat(t) : t;

        if (o.open(e.method, u), Object.keys(e.headers).forEach(function (t) {
          o.setRequestHeader(t, e.headers[t]);
        }), o.onreadystatechange = function () {
          if (4 === o.readyState) {
            var e = {
              options: s,
              statusCode: o.status,
              url: u
            },
                n = "";

            try {
              n = JSON.parse(o.responseText);
            } catch (t) {
              n = o.responseText;
            }

            if (/^(2|3)\d{2}$/.test(o.status.toString())) {
              try {
                r(q({
                  data: n
                }, e));
              } catch (t) {
                r(q({
                  data: n
                }, e));
              }

              return;
            }

            i(q({
              data: n
            }, e)), H.report(new Error(JSON.stringify({
              statusCode: o.status.toString(),
              url: t
            })));
          }
        }, o.send(c), o.onabort = function () {
          a = !0;
        }, e.timeout) {
          if (a) return;
          setTimeout(function () {
            o.abort(), new Error("XMLHttpRequest timeout").code = "ETIMEDOUT", H.report(new Error("".concat(e.baseUrl, " time out")));
          }, e.timeout);
        }
      });
    }
  }, {
    key: "buildUrl",
    value: function value(t, e) {
      var n = Object.prototype.toString.call(e);
      if (!e || "[object Object]" !== n) return t;
      var r = Object.keys(e);
      return (t = decodeURIComponent(t).indexOf("?") > -1 ? "".concat(t, "&") : "".concat(t, "?")) + r.map(function (t) {
        return "".concat(t, "=").concat(e[t]);
      }).join("&");
    }
  }]), t;
}())(),
    X = {
  Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
  Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
  iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
  MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
  Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"]
},
    $ = (K = {}, {
  set: function set(t, e) {
    K[t] = e;
  },
  get: function get(t) {
    if (K.hasOwnProperty(t)) return K[t];
  }
}),
    tt = function tt(t, e) {
  try {
    var n = function (t) {
      var e = $.get(t);
      if (e) return e.value;
      var n = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(t, ")"), "i");
      return $.set(t, {
        value: n
      }), n;
    }(t).exec(e);

    return n ? n.slice(1) : null;
  } catch (t) {
    return null;
  }
};

function et(t, e) {
  var _n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

  if (!_n) {
    if (Array.isArray(t) || (_n = function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return nt(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(t);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nt(t, e);
    }(t)) || e && t && "number" == typeof t.length) {
      _n && (t = _n);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function e(t) {
          throw t;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      _n = _n.call(t);
    },
    n: function n() {
      var t = _n.next();

      return a = t.done, t;
    },
    e: function e(t) {
      c = !0, o = t;
    },
    f: function f() {
      try {
        a || null == _n["return"] || _n["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function nt(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

var rt = function t() {
  a(this, t), u(this, "parse", function (t) {
    var e,
        n = null,
        r = et(Object.keys(X));

    try {
      for (r.s(); !(e = r.n()).done;) {
        var i,
            o = e.value,
            a = et(X[o]);

        try {
          for (a.s(); !(i = a.n()).done;) {
            var c = i.value;
            if (tt(c, t)) return n = o;
          }
        } catch (t) {
          a.e(t);
        } finally {
          a.f();
        }
      }
    } catch (t) {
      r.e(t);
    } finally {
      r.f();
    }

    return n;
  });
},
    it = "https://h.online-metrix.net/fp/tags.js",
    ot = "cybs_script",
    at = "k8vif92e",
    ct = "yyrisk",
    st = "cybs",
    ut = function () {
  var t;
  return function () {
    var e = o(h.mark(function e() {
      var n,
          r,
          i = arguments;
      return h.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = i.length > 0 && void 0 !== i[0] ? i[0] : "", !t) {
                e.next = 5;
                break;
              }

              return e.next = 4, t;

            case 4:
              return e.abrupt("return", e.sent);

            case 5:
              return r = J.get("".concat(n, "/v1/api/cashier/paysession"), {}).then(function (t) {
                return t.data.paySession;
              }), t = r, e.abrupt("return", r);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();
}(),
    lt = function () {
  function t(e) {
    a(this, t), this.host = e || "https://cashiers.myshopline.com";
  }

  return s(t, [{
    key: "init",
    value: function value() {
      var t = this;
      return ut(this.host).then(function (e) {
        document.querySelector("#".concat(ot)) || t.appendCybsScript(e);
        var n = new rt().parse(navigator.userAgent) || "Other";
        return e.label = st, e.deviceType = t.getDeviceType(n), e.deviceOS = n, e;
      });
    }
  }, {
    key: "getDeviceType",
    value: function value(t) {
      return t ? "Linux" === t || "Windows" === t || "MacOS" === t ? "PC" : "iOS" === t || "Android" === t || "HarmonyOS" === t ? "Mobile" : "Other" : "Other";
    }
  }, {
    key: "appendCybsScript",
    value: function value(t) {
      var e = ct + t.sessionId,
          n = "".concat(it, "?org_id=").concat(at, "&session_id=").concat(e);
      this.appendScript(n);
    }
  }, {
    key: "appendScript",
    value: function value(t, e) {
      var n,
          r = document.getElementsByTagName("head")[0],
          i = document.createElement("script");
      i.type = "text/javascript", i.src = t, i.id = ot, null === (n = document.querySelector("#".concat(ot))) || void 0 === n || n.remove(), i.onload = i.onreadystatechange = function () {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (e && e(), i.onload = i.onreadystatechange = null);
      }, r.appendChild(i);
    }
  }]), t;
}();

function pt(t, e, n) {
  var r = t.isForeign,
      i = void 0 === r || r,
      o = t.merchantId,
      a = t.countryCode,
      c = t.currency,
      s = t.paymentMethod,
      u = t.pvId,
      l = t.validateState,
      p = window.location.pathname,
      d = Math.floor(new Date().getTime() / 1e3),
      h = "https://".concat(i ? "shop.eclytics.com" : "eclytics.shoplineapp.cn", "/j.gif"),
      f = "act=webpaymentsdk&time=".concat(d, "&merchantId=").concat(o, "&countryCode=").concat(a, "&currency=").concat(c, "&paymentMethod=").concat(s, "&pathname=").concat(p, "&actionType=").concat(e, "&sessionId=").concat(n, "&version=").concat("1.6.0", "&pvId=").concat(u, "&validateState=").concat(l),
      y = document.createElement("img");
  y.style.display = "none", y.src = "".concat(h, "?").concat(f), y.onerror = function () {
    console.log("数据上报失败: ", e);
  };
}

function dt(t, e) {
  var _n2 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

  if (!_n2) {
    if (Array.isArray(t) || (_n2 = function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return ht(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(t);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ht(t, e);
    }(t)) || e && t && "number" == typeof t.length) {
      _n2 && (t = _n2);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function e(t) {
          throw t;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      _n2 = _n2.call(t);
    },
    n: function n() {
      var t = _n2.next();

      return a = t.done, t;
    },
    e: function e(t) {
      c = !0, o = t;
    },
    f: function f() {
      try {
        a || null == _n2["return"] || _n2["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function ht(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function ft(t, e) {
  if (!t) return null;
  var n = t.content,
      r = t.props,
      i = t.children,
      o = document.createElement(n);
  if (Object.keys(r).forEach(function (t) {
    o.setAttribute(t, r[t]);
  }), !e) return null;

  if (Array.isArray(i)) {
    var a,
        c = dt(i);

    try {
      for (c.s(); !(a = c.n()).done;) {
        ft(a.value, o);
      }
    } catch (t) {
      c.e(t);
    } finally {
      c.f();
    }
  } else "string" == typeof i ? o.textContent = i : i ? ft(i, o) : o.textContent = "";

  e.appendChild(o);
}

var yt = [],
    gt = [];

function vt(t, e) {
  if (t && "undefined" != typeof document) {
    var n,
        r = !0 === e.prepend ? "prepend" : "append",
        i = !0 === e.singleTag,
        o = "string" == typeof e.container ? document.querySelector(e.container) : document.getElementsByTagName("head")[0];

    if (i) {
      var a = yt.indexOf(o);
      -1 === a && (a = yt.push(o) - 1, gt[a] = {}), n = gt[a] && gt[a][r] ? gt[a][r] : gt[a][r] = c();
    } else n = c();

    65279 === t.charCodeAt(0) && (t = t.substring(1)), n.styleSheet ? n.styleSheet.cssText += t : n.appendChild(document.createTextNode(t));
  }

  function c() {
    var t = document.createElement("style");
    if (t.setAttribute("type", "text/css"), e.attributes) for (var n = Object.keys(e.attributes), i = 0; i < n.length; i++) {
      t.setAttribute(n[i], e.attributes[n[i]]);
    }
    var a = "prepend" === r ? "afterbegin" : "beforeend";
    return o.insertAdjacentElement(a, t), t;
  }
}

vt('.pci-tooltip-wrap {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.pci-tooltip-wrap::after {\n  display: none;\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  content: "";\n  width: 0px;\n  height: 0px;\n  transform: translateX(-50%);\n  border: 7px solid;\n  border-color: rgba(30, 30, 30, .9) transparent transparent transparent;\n}\n\n.pci-tooltip-content {\n  display: none;\n  position: absolute;\n  bottom: 26px;\n  right: -17px;\n  box-sizing: content-box;\n  width: 180px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  background-color: rgba(30, 30, 30, .9);\n  font-family: PingFang SC;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(255, 255, 255, .9);\n}\n\n.pci-tooltip-wrap:hover::after,\n.pci-tooltip-wrap:hover .pci-tooltip-content {\n  display: block;\n}', {});

var mt = function () {
  function t() {
    a(this, t);
  }

  return s(t, [{
    key: "mount",
    value: function value(t, e) {
      ft({
        content: "div",
        props: {
          "class": "pci-tooltip-wrap"
        },
        children: {
          content: "div",
          props: {
            "class": "pci-tooltip-content"
          },
          children: e
        }
      }, t);
    }
  }]), t;
}();

function Mt(t, e) {
  if (200 !== t.statusCode) return {
    paymentError: t.data
  };
  var n = t.data.nextAction,
      r = n.method,
      i = n.url,
      a = n.data,
      c = n.target,
      s = null == e ? void 0 : e.beforeRedirect,
      u = new Promise(function () {
    var t = o(h.mark(function t(e) {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (!s) {
                t.next = 9;
                break;
              }

              return t.prev = 1, t.next = 4, s(c);

            case 4:
              t.next = 9;
              break;

            case 6:
              t.prev = 6, t.t0 = t["catch"](1), console.error(t.t0);

            case 9:
              e(!0);

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[1, 6]]);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }()),
      l = new Promise(function (t) {
    setTimeout(t, 3e3);
  });
  Promise.race([u, l]).then(function () {
    "POST" === r ? function (t, e) {
      var n = document.createElement("form");

      for (var r in n.method = "post", n.action = t, e) {
        var i = document.createElement("input");
        i.name = r, i.value = e[r], n.appendChild(i);
      }

      document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }(i, a) : "GET" === r && (window.location.href = i);
  });
}

function Nt(t, e, n, r, i, o, a) {
  try {
    var c = t[o](a),
        s = c.value;
  } catch (t) {
    return void n(t);
  }

  c.done ? e(s) : Promise.resolve(s).then(r, i);
}

function It(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function wt(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function bt(t, e, n) {
  return e && wt(t.prototype, e), n && wt(t, n), t;
}

function Dt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

var xt = {
  exports: {}
};
!function (t) {
  var e = function (t) {
    var e,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        c = i.toStringTag || "@@toStringTag";

    function s(t, e, n) {
      return Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      s({}, "");
    } catch (t) {
      s = function s(t, e, n) {
        return t[e] = n;
      };
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof g ? e : g,
          o = Object.create(i.prototype),
          a = new k(r || []);
      return o._invoke = function (t, e, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return T();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var c = x(a, n);

              if (c) {
                if (c === y) continue;
                return c;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var s = l(t, e, n);

            if ("normal" === s.type) {
              if (r = n.done ? f : d, s.arg === y) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }

            "throw" === s.type && (r = f, n.method = "throw", n.arg = s.arg);
          }
        };
      }(t, n, a), o;
    }

    function l(t, e, n) {
      try {
        return {
          type: "normal",
          arg: t.call(e, n)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        y = {};

    function g() {}

    function v() {}

    function m() {}

    var M = {};

    M[o] = function () {
      return this;
    };

    var N = Object.getPrototypeOf,
        I = N && N(N(A([])));
    I && I !== n && r.call(I, o) && (M = I);
    var w = m.prototype = g.prototype = Object.create(M);

    function b(t) {
      ["next", "throw", "return"].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function D(t, e) {
      function n(i, o, a, c) {
        var s = l(t[i], t, o);

        if ("throw" !== s.type) {
          var u = s.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? e.resolve(p.__await).then(function (t) {
            n("next", t, a, c);
          }, function (t) {
            n("throw", t, a, c);
          }) : e.resolve(p).then(function (t) {
            u.value = t, a(u);
          }, function (t) {
            return n("throw", t, a, c);
          });
        }

        c(s.arg);
      }

      var i;

      this._invoke = function (t, r) {
        function o() {
          return new e(function (e, i) {
            n(t, r, e, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function x(t, n) {
      var r = t.iterator[n.method];

      if (r === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator["return"] && (n.method = "return", n.arg = e, x(t, n), "throw" === n.method)) return y;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return y;
      }

      var i = l(r, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
    }

    function j(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function O(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function k(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(j, this), this.reset(!0);
    }

    function A(t) {
      if (t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < t.length;) {
              if (r.call(t, i)) return n.value = t[i], n.done = !1, n;
            }

            return n.value = e, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: T
      };
    }

    function T() {
      return {
        value: e,
        done: !0
      };
    }

    return v.prototype = w.constructor = m, m.constructor = v, v.displayName = s(m, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, s(t, c, "GeneratorFunction")), t.prototype = Object.create(w), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, b(D.prototype), D.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = D, t.async = function (e, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new D(u(e, n, r, i), o);
      return t.isGeneratorFunction(n) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, b(w), s(w, c, "Generator"), w[o] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e.reverse(), function n() {
        for (; e.length;) {
          var r = e.pop();
          if (r in t) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, t.values = A, k.prototype = {
      constructor: k,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;

        function i(r, i) {
          return c.type = "throw", c.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              c = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (s && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (s) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), y;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];

          if (n.tryLoc === t) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: A(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), y;
      }
    }, t;
  }(xt.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
}();

var jt = xt.exports,
    Ot = function () {
  function t() {
    It(this, t), Dt(this, "iframeHost", "*");
  }

  return bt(t, [{
    key: "setUuid",
    value: function value(t) {
      this.uuid = t;
    }
  }, {
    key: "setIframeHost",
    value: function value(t) {
      this.iframeHost = t || "https://cashiers.myshopline.com";
    }
  }, {
    key: "setAttr",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setAttr",
        uuid: this.uuid,
        attr: t
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "setInitData",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "initData",
        uuid: this.uuid,
        pvId: t.pvId
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "setStyle",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          i = {
        eventType: "setStyle",
        uuid: this.uuid,
        type: e,
        name: n,
        style: t
      };
      this.postToChild(n + this.uuid, i, r);
    }
  }, {
    key: "postInput",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: t,
        uuid: this.uuid,
        isEmpty: e,
        isValid: n
      };
      this.postToParent(i, r);
    }
  }, {
    key: "postFocus",
    value: function value(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "*",
          o = {
        eventType: "focus",
        name: t,
        uuid: this.uuid,
        isEmpty: e,
        isFocus: n,
        isValid: r
      };
      this.postToParent(o, i);
    }
  }, {
    key: "postFocusToNumber",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "focus",
        name: t,
        uuid: this.uuid,
        isFocus: e
      };
      this.postToIframe("number".concat(this.uuid), r, n);
    }
  }, {
    key: "postPasteToNumber",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "paste",
        name: t,
        uuid: this.uuid
      };
      this.postToIframe("number".concat(this.uuid), n, e);
    }
  }, {
    key: "brandChange",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "brandChange",
        uuid: this.uuid,
        brand: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "postValue",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: t,
        uuid: this.uuid,
        value: e
      };
      this.postToIframe(n + this.uuid, i, r);
    }
  }, {
    key: "getValidate",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getValidate",
        uuid: this.uuid,
        hasCardName: t
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "postValidate",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "validate",
        uuid: this.uuid,
        isValid: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "getCardBrand",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, n, e);
    }
  }, {
    key: "postCardBrand",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid,
        brand: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "pay",
    value: function value(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.iframeHost,
          o = {
        eventType: "pay",
        uuid: this.uuid,
        nextAction: t,
        hasCardName: e,
        requestParams: n
      };
      this.postToChild(r + this.uuid, o, i);
    }
  }, {
    key: "payResult",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "payResult",
        uuid: this.uuid,
        status: t,
        value: e
      };
      this.postToParent(r, n);
    }
  }, {
    key: "loadFinished",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "loadFinished",
        uuid: this.uuid,
        name: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "postToChild",
    value: function value(t, e, n) {
      var r;
      null === (r = window.frames[t]) || void 0 === r || r.postMessage(e, n);
    }
  }, {
    key: "postToParent",
    value: function value(t, e) {
      window.parent.postMessage(t, e);
    }
  }, {
    key: "postToIframe",
    value: function value(t, e, n) {
      var r;
      null === (r = window.parent.frames[t]) || void 0 === r || r.postMessage(e, n);
    }
  }]), t;
}(),
    kt = function () {
  function e(t) {
    It(this, e), this.uuid = t;
  }

  return bt(e, [{
    key: "setParentDom",
    value: function value(t) {
      this.parentDom = t;
    }
  }, {
    key: "mountIframe",
    value: function value(t, e, n, r) {
      var i = this.parentDom.querySelector(t);

      if (i) {
        var o = document.createElement("iframe");
        o.onload = r, o.src = n, o.name = e, o.id = e, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", i.innerHTML = "", i.appendChild(o);
      } else console.error("Can't find the related dom node to mount the iframe");
    }
  }, {
    key: "unmountDom",
    value: function value(t) {
      var e = this.parentDom.querySelector(t);
      e && (e.innerHTML = "");
    }
  }, {
    key: "renderIframe",
    value: function value(e, n, r, i) {
      var o = this,
          a = e ? "".concat(e, "/pci-sdk") : "https://cashiers.myshopline.com/pci-sdk";
      n.forEach(function (e) {
        var n = "".concat(a, "/iframe.html?name=").concat(e);
        o.mountIframe('[data-pci="'.concat(e, '"]'), "".concat(e).concat(o.uuid), n, function () {
          var n = r.placeholder;
          i.setInitData({
            pvId: t
          }, e), n && n[e] && i.setAttr({
            placeholder: n[e]
          }, e);
        });
      });
    }
  }]), e;
}(),
    At = function () {
  function t(e) {
    It(this, t), Dt(this, "config", {}), Dt(this, "iframeLoaded", {}), this.config = e;
  }

  return bt(t, [{
    key: "setValidateResolve",
    value: function value(t) {
      this.validateResolve = t;
    }
  }, {
    key: "setPayResolve",
    value: function value(t) {
      this.payResolve = t;
    }
  }, {
    key: "setPayReject",
    value: function value(t) {
      this.payReject = t;
    }
  }, {
    key: "setCardBrandResolve",
    value: function value(t) {
      this.cardBrandResolve = t;
    }
  }, {
    key: "setIframeLoaded",
    value: function value(t) {
      var e = this;
      t.forEach(function (t) {
        return e.iframeLoaded[t] = !1;
      });
    }
  }, {
    key: "handleEvent",
    value: function value(t) {
      var e = this,
          n = t.eventType,
          r = t.name,
          i = t.isEmpty,
          o = t.isValid,
          a = t.brand,
          c = t.isFocus,
          s = t.status,
          u = t.value;
      "focus" === n ? this.triggerEvent("onFocus", {
        fieldName: r,
        isEmpty: i,
        isFocus: c,
        isValid: o
      }) : "input" === n ? this.triggerEvent("onFieldValidChange", {
        fieldName: r,
        isValid: o,
        isEmpty: i
      }) : "brandChange" === n ? this.triggerEvent("onBrandChange", {
        brand: a
      }) : "validate" === n ? this.validateResolve(o) : "payResult" === n ? "success" === s ? this.payResolve(u) : this.payReject(u) : "getCardBrand" === n ? this.cardBrandResolve(a) : "loadFinished" === n && (this.iframeLoaded[r] = !0, Object.keys(this.iframeLoaded).every(function (t) {
        return e.iframeLoaded[t];
      }) && this.triggerEvent("onInit", {}));
    }
  }, {
    key: "triggerEvent",
    value: function value(t, e) {
      this.config[t] && this.config[t](e);
    }
  }]), t;
}(),
    Tt = ["number", "expDate", "cvc", "firstName"],
    Et = function () {
  function t(e) {
    var n;
    It(this, t), Dt(this, "config", {}), Dt(this, "postMessageInstance", new Ot()), Dt(this, "hasCardName", !0), this.host = e.host || "", this.uuid = (n = new Date().getTime(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var e = (n + 16 * Math.random()) % 16 | 0;
      return n = Math.floor(n / 16), ("x" == t ? e : 3 & e | 8).toString(16);
    })), this.postMessageInstance.setUuid(this.uuid), this.postMessageInstance.setIframeHost(this.host), this.cardIframeInstance = new kt(this.uuid);
  }

  var e, n;
  return bt(t, [{
    key: "create",
    value: function value(t) {
      this.config = t, this.cardEventInstance = new At(t);
    }
  }, {
    key: "mount",
    value: function value(t) {
      var e = this,
          n = "string" == typeof t ? document.querySelector(t) : t;

      if (this.mountDom = n, this.cardIframeInstance.setParentDom(n), n) {
        this.hasCardName = !!n.querySelector('[data-pci="firstName"]');
        var r = this.hasCardName ? Tt : Tt.slice(0, 3);
        this.cardIframeInstance.renderIframe(this.host, r, this.config, this.postMessageInstance), this.cardEventInstance.setIframeLoaded(r), window.addEventListener("message", function (t) {
          t.data.uuid === e.uuid && e.cardEventInstance.handleEvent(t.data);
        });
      } else console.error("Can't find the mount dom");
    }
  }, {
    key: "setStyle",
    value: function value(t) {
      var e = t.type,
          n = t.fieldName,
          r = t.style;
      this.postMessageInstance.setStyle(r, e, n);
    }
  }, {
    key: "destroy",
    value: function value() {
      var t = this;
      this.mountDom && Tt.forEach(function (e) {
        return t.cardIframeInstance.unmountDom('[data-pci="'.concat(e, '"]'));
      });
    }
  }, {
    key: "validate",
    value: (e = jt.mark(function t() {
      var e = this;
      return jt.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", new Promise(function (t) {
                e.cardEventInstance.setValidateResolve(t), e.postMessageInstance.getValidate(e.hasCardName, "number");
              }));

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }), n = function n() {
      var t = this,
          n = arguments;
      return new Promise(function (r, i) {
        var o = e.apply(t, n);

        function a(t) {
          Nt(o, r, i, a, c, "next", t);
        }

        function c(t) {
          Nt(o, r, i, a, c, "throw", t);
        }

        a(void 0);
      });
    }, function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: function value(t) {
      var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (r, i) {
        e.cardEventInstance.setPayResolve(r), e.cardEventInstance.setPayReject(i), e.postMessageInstance.pay(t, e.hasCardName, n, "number");
      });
    }
  }, {
    key: "getCardBrand",
    value: function value() {
      var t = this;
      return new Promise(function (e) {
        t.cardEventInstance.setCardBrandResolve(e), t.postMessageInstance.getCardBrand("number");
      });
    }
  }]), t;
}();

var zt = {
  splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    St = {
  splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    Ct = function Ct(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return {
    tagName: t,
    content: e,
    property: n
  };
},
    Lt = function Lt(t, e, n, r) {
  return e + (n ? n.slice(1) : "") + r;
},
    Ut = function () {
  function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t);
  }

  var e;
  return (e = [{
    key: "parseToTagConfig",
    value: function value(t) {
      var e = [],
          n = St,
          r = zt;
      if (!t || 0 !== t.indexOf("$RT$")) return [Ct("text", t)];
      t = t.slice("$RT$".length);
      var i = "(".concat(r.splitReg, ")|(").concat(n.splitReg, ")");
      return t.split(new RegExp(i)).filter(function (t) {
        return !!t;
      }).forEach(function (t) {
        var i;

        if (new RegExp(r.matchReg).test(t)) {
          var o = t.match(r.matchReg);
          i = Ct("img", "", {
            alt: o[1],
            src: o[2]
          });
        } else if (new RegExp(n.matchReg).test(t)) {
          var a = t.match(n.matchReg);
          i = Ct("a", a[1], {
            href: a[2],
            target: "_blank"
          });
        } else if (new RegExp(r.replaceReg).test(t)) {
          var c = t.replace(new RegExp(r.replaceReg, "g"), Lt);
          i = Ct("text", c);
        } else if (new RegExp(n.replaceReg).test(t)) {
          var s = t.replace(new RegExp(n.replaceReg, "g"), Lt);
          i = Ct("text", s);
        } else i = Ct("text", t);

        e.push(i);
      }), e;
    }
  }, {
    key: "parseToDom",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = document.createElement(e);
      return t.forEach(function (t) {
        var e = document.createElement("text" === t.tagName ? "span" : t.tagName);
        e.textContent = t.content, t.property && Object.keys(t.property).forEach(function (n) {
          return e.setAttribute(n, t.property[n]);
        }), n.appendChild(e);
      }), n;
    }
  }, {
    key: "autoParseToDom",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = this.parseToTagConfig(t);
      return this.parseToDom(n, e);
    }
  }]) && function (t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }(t.prototype, e), t;
}();

vt(".pci-container * {\n  margin: 0;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n}\n\n.pci-container {\n  margin: 0 auto;\n}\n\n.pci-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.pci-content-form {\n  position: relative;\n  flex: 0 1 100%;\n}\n.pci-content-loading .pci-input-container{\n  background: rgba(221, 221, 216, 0.3);\n  border-radius: 4px;\n  height: 48px;\n}\n\n.pci-content-loading .pci-input-box,\n.pci-content-loading .pci-icon{\n  display: none;\n}\n\n.pci-name-box{\n  position: relative;\n  /* max-width: 401px; */\n}\n\n.pci-dateAndCvc-box{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.pci-pc-style .pci-dateAndCvc-box .pci-input-container{\n  width: 50%;\n  margin-bottom: 0 !important;\n}\n\n.pci-dateAndCvc-box > .pci-input-container:first-child {\n  margin-right: 16px;\n}\n\n.pci-name-box{\n  margin-bottom: 16px;\n}\n\n.pci-input-tip{\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  color: rgba(30, 30, 30, .6);\n  overflow: hidden;\n  transition: all 0.2s linear;\n}\n\n.pci-input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: 16px;\n  overflow: visible;\n}\n\n.pci-input-container:last-child,\n.pci-input-container:last-child .pci-input-box {\n  margin-bottom: 0;\n}\n\n.pci-input-box {\n  position: relative;\n  height: 48px;\n  box-sizing: border-box;\n  border: 1px solid rgba(216, 216, 216, 1);\n  border-radius: 4px;\n  /* padding: 0 28px 0 16px; */\n  overflow: hidden;\n  background-color: #fff;\n  z-index: 1;\n}\n\n.pci-input-box-focus .pci-input-label {\n  font-size: 10px;\n  transform: translateY(-9px);\n  transition: all 0.2s linear;\n}\n\n.pci-input-box-focus .pci-input-content {\n  /* transform: translateY(20px);\n  transition: all 0.2s linear; */\n  height: 46px;\n}\n\n.pci-input-box-focus .pci-input-content input{\n  transition: all 0.2s linear;\n  padding: 20px 28px 0 16px;\n}\n\n.pci-input-valid-error-box .pci-input-box {\n  border-color: #F04949;\n}\n\n.pci-input-content {\n  height: 100%;\n  background-color: transparent;\n}\n\n.pci-number-icon,\n.pci-firstName-icon,\n.pci-cvc-icon {\n  position: absolute;\n  top: 18px;\n  right: 16px;\n  width: 12px;\n  height: 12px;\n  z-index: 10;\n}\n\n.pci-input-label {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  font-size: 14px;\n  line-height: 16px;\n  color: rgba(30, 30, 30, .6);\n  pointer-events: none;\n  transition: all 0.2s linear;\n  white-space: nowrap;\n}\n\n.pci-number-icon {\n  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAMFBMVEUAAAAsLCwrKysrKysqKiosLCwsLCwsLCwsLCwrKysrKysrKysoKCgwMDAgICAsLCxtrb2NAAAAD3RSTlMA71/fYIBAz7+gn28gEBAlgKsTAAAAb0lEQVQY02PAAE/tv6+BsZnk////uAHK2f8jj23+JwibRz6AgYH14wUwh/MXiOwPAHPYv4HIfAMwh/8DiLz/AYnDj8lR/A8FRkCOPYzzEcj5D3PIf4IcFgUkjv8nFA6GMuKNloc55zOQ4wzjiDAAAGKaUE9NYyRqAAAAAElFTkSuQmCC') no-repeat center/12px auto;\n}\n\n.pci-number-brand-icon {\n  top: 12px;\n  right: 12px;\n  width: 38px;\n  height: 24px;\n}\n\n.pci-firstName-icon,\n.pci-cvc-icon {\n  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAM1BMVEUAAAAoKCgsLCwrKyssLCwrKyssLCwsLCwoKCgrKysrKyssLCwsLCwsLCwrKysqKiosLCxgiKW/AAAAEHRSTlMAIO/fv3CAUBCgn39vr5AwZxK4SQAAALlJREFUKM91UlsShCAMg7Y8FIHc/7TbXSrD4pgfCyGpNDhDLsIAyeXdCi+YOBfqIlBLutHTAVBwhgLUPMVKFTsPhNU32toT4thhHt8A+vY5cNpRwIoKUQHgdyITsgsq2AnX1F2QnkRSL0J/Eh68rLbyleDxU3YPQwdZc8PaPKI9iQPBZZAN0DMPV7u0oM7hxVtwjiGGf0UB/YowA9hjiGueuU5H1ZBSqatbamTRzjwnZHsnlxDAEu/wP7OKCP+rpH6CAAAAAElFTkSuQmCC') no-repeat center/12px;\n}\n\n.pci-error-tip {\n  font-size: 12px;\n  line-height: 17px;\n  color: #F04949;\n  height: 0;\n  overflow: hidden;\n  transition: all 0.2s linear;\n}\n\n.pci-input-valid-error .pci-error-tip{\n  transition: all 0.2s linear;\n}\n\n.pci-card {\n  flex: 0 1 316px;\n  height: 176px;\n  padding: 24px 24px 0;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, #CFCFCF 0%, #C4C3C3 100%);\n  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n}\n\n.pci-card-logo {\n  width: 64px;\n  height: 40px;\n  margin-bottom: 24px;\n  background: #FFFFFF;\n  opacity: 0.4;\n  border-radius: 2px;\n}\n\n.pci-card-number {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.pci-card-number-dot-list {\n  width: 48px;\n  height: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pci-card-number-dot-item {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n.pci-card-nameAndexpDate{\n  display: flex;\n  justify-content: space-between;\n}\n\n.pci-card-name,\n.pci-card-expDate {\n  float: right;\n  text-align: right;\n}\n\n.pci-card-name p,\n.pci-card-expDate p {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.pci-card-name .pci-card-number-dot-list{\n  float: left;\n}\n\n.pci-card-expDate .pci-card-number-dot-list {\n  float: right;\n}\n\n.pci-footer {\n  text-indent: 20px;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(30, 30, 30, .4);\n  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjg3NzMgNS4zMzMzNEgxMC4xNTU3QzkuOTk4ODIgNS4zMzMzNCA5Ljg0OTU4IDUuNDA1MjYgOS43NTcyNyA1LjUyODUzTDcuMzM4NzMgOC43Mjc5TDYuMjQzMzEgNy4yNzc5MUM2LjE1MSA3LjE1NjEgNi4wMDMzIDcuMDgyNzIgNS44NDQ4NCA3LjA4MjcySDUuMTIzMjhDNS4wMjMyNyA3LjA4MjcyIDQuOTY0ODEgNy4xOTEzMyA1LjAyMzI3IDcuMjY5MTFMNi45NDAyNiA5LjgwNTEyQzYuOTg1NTQgOS44NjU0MiA3LjA0NTI0IDkuOTE0NTUgNy4xMTQ0MSA5Ljk0ODQ0QzcuMTgzNTcgOS45ODIzMyA3LjI2MDIxIDEwIDcuMzM3OTYgMTBDNy40MTU3MiAxMCA3LjQ5MjM1IDkuOTgyMzMgNy41NjE1MiA5Ljk0ODQ0QzcuNjMwNjggOS45MTQ1NSA3LjY5MDM4IDkuODY1NDIgNy43MzU2NyA5LjgwNTEyTDEwLjk3NTggNS41MTk3M0MxMS4wMzU4IDUuNDQxOTUgMTAuOTc3MyA1LjMzMzM0IDEwLjg3NzMgNS4zMzMzNFoiIGZpbGw9IiMzNUMwOEUiLz4KPHBhdGggZD0iTTIuNzUgMy40Njg4NUMyLjc1IDMuMzUxNjcgMi44MzEzOCAzLjI1MDIyIDIuOTQ1NzcgMy4yMjQ4TDcuOTQ1NzcgMi4xMTM2OUM3Ljk4MTQ5IDIuMTA1NzUgOC4wMTg1MSAyLjEwNTc1IDguMDU0MjMgMi4xMTM2OUwxMy4wNTQyIDMuMjI0OEMxMy4xNjg2IDMuMjUwMjIgMTMuMjUgMy4zNTE2NyAxMy4yNSAzLjQ2ODg1VjkuNTk2MzFDMTMuMjUgMTAuMDE0MiAxMy4wNDExIDEwLjQwNDUgMTIuNjkzNCAxMC42MzY0TDguMTM4NjcgMTMuNjcyOEM4LjA1NDcgMTMuNzI4OCA3Ljk0NTMgMTMuNzI4OCA3Ljg2MTMyIDEzLjY3MjhMMy4zMDY2MiAxMC42MzY0QzIuOTU4ODggMTAuNDA0NSAyLjc1IDEwLjAxNDMgMi43NSA5LjU5NjMxVjMuNDY4ODVaIiBzdHJva2U9IiMzNUMwOEUiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=') no-repeat left top/12px 14px;\n}\n\n.pci-footer a,\n.pci-footer a:hover,\n.pci-footer a:active{\n  color: #466C63;\n  text-decoration: none;\n}\n\n.pci-footer-tips {\n  word-break : break-word;\n}\n\n.pci-footer-tips img {\n  width: 20px;\n}\n\n.pci-footer-loading {\n  background: rgba(221, 221, 216, 0.3);\n  border-radius: 4px;\n  height: 10px;\n}\n\n.pci-footer-loading .pci-footer-tips{\n  display: none;\n}\n\n.pci-mobile-style{\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* 小屏幕不展示卡片 */\n.pci-mobile-style .pci-container,\n.pci-mobile-style {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.pci-mobile-style .pci-content-form{\n  flex: auto\n}\n\n.pci-mobile-style .pci-bind-card-container{\n  width: 100%;\n}\n\n.pci-mobile-style .pci-name-box{\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box{\n  display: block;\n}\n\n.pci-mobile-style .pci-input-box{\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-input-container{\n  width: 100%;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box .pci-input-container{\n  margin-bottom: 16px;\n  margin-right: 0;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box .pci-input-container:last-child{\n  margin-bottom: 0 !important;\n}\n\n.pci-mobile-style .pci-card {\n  display: none;\n}", {});
var Pt = ["fieldName"];

function Qt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Rt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Qt(Object(n), !0).forEach(function (e) {
      u(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Qt(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var Yt = function () {
  function e(t) {
    var n = this;
    a(this, e), u(this, "validateResult", {}), u(this, "insertLanguage", function (t) {
      var e, r;
      n.language = t, n.hasTipsArray = [];
      var i = t.formItems;

      if (Object.keys(i).forEach(function (e) {
        var r = n.container.querySelector("#pci-input-".concat(e, "-label")),
            o = n.container.querySelector("#pci-input-".concat(e, "-container"));
        (r.textContent = t.formItems[e].labelTitle, i[e].tips && n.hasTipsArray.push({
          key: e,
          content: i[e].tips
        }), n.validateResult[e] = {
          isValid: !1,
          isEmpty: !0
        }, i[e].tips) && ft({
          content: "div",
          props: {
            id: "pci-".concat(e, "-icon"),
            "class": "pci-icon pci-".concat(e, "-icon")
          },
          children: null
        }, o);
        "firstName" === e && (n.container.querySelector("#pci-input-name-tip").textContent = t.pleaseEnterNameOnCardOrBusinessName);
      }), n.hasTipsArray.length > 0) {
        var o = new mt();
        n.hasTipsArray.forEach(function (t) {
          var e = n.container.querySelector("#pci-".concat(t.key, "-icon"));
          o.mount(e, t.content);
        });
      }

      var a,
          c = "".concat((null == t || null === (e = t.content) || void 0 === e || null === (r = e.creditCard) || void 0 === r ? void 0 : r.serviceTips) || "").concat((null == t ? void 0 : t.footer) || ""),
          s = new Ut();
      c && (null === (a = n.container.querySelector(".pci-footer-tips")) || void 0 === a || a.appendChild(s.autoParseToDom(c)));
      return n.pciSdk.mount(".pci-content-form-".concat(n.uuid)), new Promise(function (t) {
        n.memoryResolve = t;
      });
    }), u(this, "needShowPcStyle", function (t) {
      n.isPc = t;
      var e = n.container.querySelector("#pci-container");

      if (e) {
        var r = e.getAttribute("class");
        r = r.replace(/(\s*pci-mobile-style)|(\s*pci-pc-style)/g, ""), r += " ".concat(t ? "pci-pc-style" : "pci-mobile-style"), e.setAttribute("class", r);
        ["number", "firstName", "expDate", "cvc"].forEach(function (t) {
          var e,
              r = null === (e = n.container) || void 0 === e ? void 0 : e.querySelector("#pci-".concat(t, "-error"));

          if (r) {
            var i = null == r ? void 0 : r.textContent,
                o = null == r ? void 0 : r.parentElement;
            i && o && (o.style.height = "".concat(r.offsetHeight, "px"));
          }
        });
      }
    }), u(this, "createErrorDom", function (t) {
      return {
        content: "div",
        props: {
          "class": "pci-error-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-".concat(t, "-error")
          }
        }
      };
    }), u(this, "handleFocusInput", function (t) {
      var e = t.fieldName,
          r = t.isEmpty,
          i = t.isFocus,
          o = t.isValid,
          a = n.container.querySelector("#pci-input-".concat(e, "-content")).parentElement,
          c = a.getAttribute("class"),
          s = !1;
      n.validateResult[e].isValid = o, !r && !i || c.includes("pci-input-box-focus") ? !i && r && c.includes("pci-input-box-focus") && (c = c.replace(" pci-input-box-focus", "")) : c += " pci-input-box-focus", i ? (n.setError(e, ""), s = !0) : s = !1, "firstName" === e && n.handleShowOrHideDom({
        id: "pci-input-name-tip",
        type: "tip",
        className: "pci-input-tip-show",
        show: s
      });
      var u = "";

      if (!i && !r) {
        var l = !1;
        n.validateResult[e].isValid ? (l = !0, n.isSupportCardBrand || "number" !== e || (l = !1, u = n.language.cardIsNotSupported)) : u = n.language.formItems[e].errorTips, l ? n.setError(e, "") : n.setError(e, u);
      }

      a.setAttribute("class", c);
    }), u(this, "handleShowOrHideDom", function (t) {
      var e = t.id,
          r = t.className,
          i = t.type,
          o = t.content,
          a = t.show,
          c = n.container.querySelector("#".concat(e));
      if (!c) return null;
      var s = c.parentElement,
          u = s.parentElement,
          l = s.getAttribute("class"),
          p = u.getAttribute("class");
      "error" === i && (c.textContent = o), !o && !0 !== a || l.includes("".concat(r)) ? "" !== o && !1 !== a || !l.includes("".concat(r)) || (s.style.height = "0px", l = l.replace(" ".concat(r), ""), "error" === i && (p = p.replace(" pci-input-valid-error-box", ""))) : (l += " ".concat(r), s.style.height = "".concat(c.offsetHeight, "px"), "error" === i && (p += " pci-input-valid-error-box")), s.setAttribute("class", l), "error" === i && u.setAttribute("class", p);
    }), u(this, "onBrandChange", function (t) {
      n.cardBrand = t.brand, n.cardBrand && n.supportCardBrands.length && -1 === n.supportCardBrands.indexOf(n.cardBrand) ? n.isSupportCardBrand = !1 : n.isSupportCardBrand = !0, n.setBrandIcon(n.cardBrand);
    }), u(this, "onFieldValidChange", function (t) {
      var e = t.fieldName,
          r = f(t, Pt);
      n.validateResult[e] = Rt(Rt({}, n.validateResult[e]), r), t.isEmpty && n.setError(e, "");
    }), u(this, "pciSdkInit", function () {
      n.memoryResolve(!0);
      var t = n.container.querySelector("#pci-content-form"),
          e = t.getAttribute("class").replace(" pci-content-loading", "");
      t.setAttribute("class", e);
      var r = n.container.querySelector(".pci-footer"),
          i = r.getAttribute("class").replace(" pci-footer-loading", "");
      r.setAttribute("class", i);
      ["number", "firstName", "expDate", "cvc"].forEach(function (t) {
        n.pciSdk.setStyle({
          type: "base",
          fieldName: t,
          style: {
            padding: "20px 28px 0 16px"
          }
        });
      }), console.log("pciSdk Init 完成");
    }), this.paymentInitData = t, this.paymentMethod = t.paymentMethod, this.channelId = t.channelId, this.uuid = function () {
      var t = new Date().getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var n = (t + 16 * Math.random()) % 16 | 0;
        return t = Math.floor(t / 16), ("x" == e ? n : 3 & n | 8).toString(16);
      });
    }(), this.pciSdk = new Et({
      host: t.host
    }), this.supportCardBrands = [], this.pciSdk.create({
      placeholder: {},
      onInit: this.pciSdkInit,
      onFocus: this.handleFocusInput,
      onBrandChange: this.onBrandChange,
      onFieldValidChange: this.onFieldValidChange
    });
  }

  var n, r;
  return s(e, [{
    key: "render",
    value: function value(t) {
      this.container = t, t.setAttribute("ontouchstart", ""), this.mutationObserver(), ft({
        content: "div",
        props: {
          id: "pci-container",
          "class": "pci-container ".concat(this.isPc ? "pci-pc-style" : "pci-mobile-style")
        },
        children: [{
          content: "div",
          props: {
            "class": "pci-content"
          },
          children: {
            content: "div",
            props: {
              "class": "pci-content-form pci-content-loading pci-content-form-".concat(this.uuid),
              id: "pci-content-form"
            },
            children: this.createFormItemsDom()
          }
        }, {
          content: "div",
          props: {
            "class": "pci-footer pci-footer-loading",
            id: "pci-footer"
          },
          children: {
            content: "div",
            props: {
              "class": "pci-footer-tips"
            }
          }
        }]
      }, t), this.themeSetting();
    }
  }, {
    key: "themeSetting",
    value: function value() {
      var t;

      if (null !== (t = this.paymentInitData) && void 0 !== t && t.theme) {
        var e = this.paymentInitData.theme,
            n = (void 0 === e ? {} : e)[p.CreditCard] || {};
        null != n && n.inputBackground && Array.from(this.container.querySelectorAll(".pci-input-box")).forEach(function (t) {
          t.style.background = null == n ? void 0 : n.inputBackground;
        }), null != n && n.formItemGutter && Array.from(this.container.querySelectorAll(".pci-input-container")).forEach(function (t) {
          t.style.marginBottom = null == n ? void 0 : n.formItemGutter;
        });
      }
    }
  }, {
    key: "createFormItemsDom",
    value: function value() {
      var t = !!d[this.paymentInitData.channelId],
          e = this.createFormItem("number"),
          n = t ? null : this.createFormItem("firstName"),
          r = this.createFormItem("expDate"),
          i = this.createFormItem("cvc"),
          o = [e, n, {
        content: "div",
        props: {
          "class": "".concat(t ? "" : "pci-dateAndCvc-box")
        },
        children: [r, i]
      }];
      return t && o.splice(1, 1), o;
    }
  }, {
    key: "createFormItem",
    value: function value(t) {
      var e = {
        content: "div",
        props: {
          "class": "pci-input-container",
          id: "pci-input-".concat(t, "-container")
        },
        children: [{
          content: "div",
          props: {
            "class": "pci-input-box"
          },
          children: [{
            content: "label",
            props: {
              "class": "pci-input-label",
              id: "pci-input-".concat(t, "-label")
            }
          }, {
            content: "div",
            props: {
              "data-pci": t,
              "class": "pci-input-content",
              id: "pci-input-".concat(t, "-content")
            }
          }]
        }]
      };

      if ("firstName" === t) {
        var n = this.createNameEnterTipDom();
        e.children.push(n);
      }

      var r = this.createErrorDom(t);
      return e.children.push(r), e;
    }
  }, {
    key: "createNameEnterTipDom",
    value: function value() {
      return {
        content: "div",
        props: {
          "class": "pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-input-name-tip"
          }
        }
      };
    }
  }, {
    key: "setError",
    value: function value(t, e) {
      var n = "pci-".concat(t, "-error");
      this.handleShowOrHideDom({
        id: n,
        type: "error",
        className: "pci-input-valid-error",
        content: e
      });
    }
  }, {
    key: "validate",
    value: (r = o(h.mark(function e() {
      var n,
          r,
          i = this;
      return h.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = !0, Object.keys(this.validateResult).forEach(function (t) {
                var e = i.validateResult[t],
                    r = "";
                !e.isEmpty && e.isValid || (r = i.language.formItems[t].errorTips, n = !1), i.setError(t, r);
              }), this.cardBrand) {
                e.next = 6;
                break;
              }

              return e.next = 5, this.pciSdk.getCardBrand();

            case 5:
              this.cardBrand = e.sent;

            case 6:
              if (this.validateResult.number.isValid && this.cardBrand && this.supportCardBrands.length && -1 === this.supportCardBrands.indexOf(this.cardBrand) && (this.isSupportCardBrand = !1, n = !1, r = this.language.cardIsNotSupported, this.setError("number", r), pt({
                pvId: t,
                validateState: "".concat(n, "_").concat(this.cardBrand)
              }, "validate_card", null)), !n) {
                e.next = 11;
                break;
              }

              return e.next = 10, this.pciSdk.validate();

            case 10:
              n = e.sent;

            case 11:
              return e.abrupt("return", n);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = o(h.mark(function t(e, n) {
      var r, i;
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, o = void 0, a = void 0, c = void 0, s = void 0, u = void 0, l = void 0, p = void 0, d = void 0, h = void 0, o = {}, a = window.navigator, c = a.userAgent, s = a.language, u = window.screen, l = u.colorDepth, p = u.width, d = u.height, h = window.navigator.javaEnabled().toString(), o.client = {
                transactionWebSite: window.location.href,
                javaEnabled: h,
                colorDepth: l.toString(),
                screenHeight: p.toString(),
                screenWidth: d.toString(),
                timeZoneOffset: new Date().getTimezoneOffset().toString(),
                accept: "application/json",
                userAgent: c,
                language: s
              }, r = o, t.next = 4, this.pciSdk.pay(e, Rt({
                paymentMethod: this.paymentMethod
              }, r));

            case 4:
              return i = t.sent, t.abrupt("return", Mt(i, n));

            case 8:
              return t.prev = 8, t.t0 = t["catch"](0), 400 === t.t0.statusCode && this.getErrorFromServer(t.t0.data), t.abrupt("return", Mt(t.t0));

            case 12:
            case "end":
              return t.stop();
          }
        }

        var o, a, c, s, u, l, p, d, h;
      }, t, this, [[0, 8]]);
    })), function (t, e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "setSupportCardBrands",
    value: function value(t) {
      this.supportCardBrands = t;
    }
  }, {
    key: "getErrorFromServer",
    value: function value(t) {
      var e = "",
          n = "";

      switch (t.code) {
        case "4455":
          e = "number", n = this.language.pleaseEnterValidCardNumber;
          break;

        case "3001":
          e = "number", n = this.language.pleaseChangeAnotherCard;
          break;

        case "4459":
          e = "expDate", n = this.language.pleaseEnterExpired;
          break;

        case "4453":
          e = "cvc", n = this.language.pleaseEnterCVV;
      }

      n && (this.setError(e, n), this.validateResult[e].isValid = !1);
    }
  }, {
    key: "mutationObserver",
    value: function value() {
      var t = this,
          e = this.paymentInitData.needAdaptive,
          n = void 0 === e || e,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var e = getComputedStyle(t.container).getPropertyValue("width").replace("px", "");
          t.needShowPcStyle(Number(e) > r);
        }, 200);
      });
    }
  }, {
    key: "setBrandIcon",
    value: function value(t) {
      var e = this.container.querySelector("#pci-number-icon"),
          n = e.querySelector(".pci-tooltip-wrap"),
          r = this.paymentInitData.host;
      t ? (e.classList.add("pci-number-brand-icon"), e.style.background = "center/contain no-repeat url(".concat(r || "https://cashiers.myshopline.com", "/payment-sdk/assets/image/").concat(encodeURIComponent(t), ".png)"), n.style.display = "none") : (e.classList.remove("pci-number-brand-icon"), n.removeAttribute("style"), e.removeAttribute("style"));
    }
  }]), e;
}();

function Bt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function _t(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Bt(Object(n), !0).forEach(function (e) {
      u(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Bt(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function Ft(t, e, n) {
  return Wt.apply(this, arguments);
}

function Wt() {
  return (Wt = o(h.mark(function t(e, n, r) {
    var i, o, a, c, s, u, l, p;
    return h.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            return i = {
              cardNumber: "number",
              firstName: "firstName",
              expiryDate: "expDate",
              cvc: "cvc"
            }, a = (o = "string" == typeof (e = e || "en")) ? {} : _t({}, e), c = {}, s = a.formItems, u = void 0 === s ? {} : s, t.prev = 6, t.next = 9, J.get("".concat(r || "https://cashiers.myshopline.com", "/payment-sdk/assets/i18n/").concat(o ? e : (null === (l = a) || void 0 === l ? void 0 : l.extend) || "en", ".json?hash=1.2"));

          case 9:
            200 === (p = t.sent).statusCode ? (Object.keys(i).forEach(function (t) {
              var e = p.data.formItems;
              (n || "firstName" !== t) && (c[i[t]] = _t(_t({}, e[t]), u[t]));
            }), a = _t(_t(_t({}, p.data), a), {}, {
              formItems: c
            })) : console.error("languageError: ".concat(p)), t.next = 16;
            break;

          case 13:
            t.prev = 13, t.t0 = t["catch"](6), console.error("languageError: ".concat(t.t0));

          case 16:
            return t.abrupt("return", a);

          case 17:
          case "end":
            return t.stop();
        }
      }
    }, t, null, [[6, 13]]);
  }))).apply(this, arguments);
}

function Gt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ht(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Gt(Object(n), !0).forEach(function (e) {
      u(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var Vt = function () {
  function t(e, n) {
    a(this, t), this.initData = e, n && (this.containerElement = n);
  }

  var e, n, r, i;
  return s(t, [{
    key: "validate",
    value: (i = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.pciUiInstance.validate();

            case 2:
              return t.abrupt("return", t.sent);

            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function () {
      return i.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (r = o(h.mark(function t(e, n) {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.pciUiInstance.pay(e, n);

            case 2:
              return t.abrupt("return", t.sent);

            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t, e) {
      return r.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (n = o(h.mark(function t(e) {
      var n;
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (e || this.containerElement) {
                t.next = 2;
                break;
              }

              return t.abrupt("return");

            case 2:
              return this.containerElement = e, this.pciUiInstance = new Yt(Ht({}, this.initData)), this.pciUiInstance.render(e), t.next = 7, Ft(this.initData.language, !d[this.initData.channelId], this.initData.host);

            case 7:
              return n = t.sent, t.next = 10, this.pciUiInstance.insertLanguage(n);

            case 10:
              return t.abrupt("return", t.sent);

            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "setSupportCardBrands",
    value: function value(t) {
      this.pciUiInstance.setSupportCardBrands(t);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement.innerHTML = "", this.pciUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (e = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}(),
    Zt = function () {
  function t() {
    a(this, t);
  }

  var e, n, r, i;
  return s(t, [{
    key: "validate",
    value: (i = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return i.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (r = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return");

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = o(h.mark(function t(e, n) {
      var r;
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, J.post(e.url, {
                paymentInstrument: {
                  paymentMethod: p.BankTransfer
                }
              });

            case 3:
              return r = t.sent, t.abrupt("return", Mt(r, n));

            case 7:
              return t.prev = 7, t.t0 = t["catch"](0), 400 !== t.t0.statusCode && (t.t0.data = {
                code: "2905",
                msg: "Payment failed due to network error",
                channelCode: "",
                channelMsg: ""
              }), t.abrupt("return", Mt(t.t0));

            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    })), function (t, e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {}
  }, {
    key: "needRenderWidget",
    value: (e = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !1);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}();

vt(".paypal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.paypal-container .paypal-img {\n  width: 172px;\n  height: 92px;\n  background-image: url('data:image/svg+xml;base64,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');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  margin-bottom: 20px;\n}\n\n.paypal-container .paypal-tips {\n  font-size: 12px;\n  line-height: 17px;\n  color: #BEC1CC;\n  font-family: PingFang SC;\n}", {});

var qt = function () {
  function t() {
    a(this, t);
  }

  return s(t, [{
    key: "render",
    value: function value(t) {
      this.container = t;
      ft({
        content: "div",
        props: {
          "class": "paypal-container"
        },
        children: [{
          content: "div",
          props: {
            "class": "paypal-img"
          }
        }, {
          content: "div",
          props: {
            "class": "paypal-tips"
          },
          children: "After clicking “Pay Now”, you will be redirected to PayPal to complete your purchase securely."
        }]
      }, t);
    }
  }]), t;
}(),
    Kt = function Kt(t, e) {
  return new Promise(function () {
    var n = o(h.mark(function n(r, i) {
      var o;
      return h.wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, J.post(t, e);

            case 3:
              o = n.sent, r(o), n.next = 11;
              break;

            case 7:
              n.prev = 7, n.t0 = n["catch"](0), 400 !== n.t0.statusCode && (n.t0.data = {
                code: "2905",
                msg: "Payment failed due to network error",
                channelCode: "",
                channelMsg: ""
              }), i(n.t0);

            case 11:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }));
    return function (t, e) {
      return n.apply(this, arguments);
    };
  }());
},
    Jt = function () {
  function t(e, n) {
    a(this, t), this.initData = e, n && (this.containerElement = n);
  }

  var e, n, r, i;
  return s(t, [{
    key: "render",
    value: (i = o(h.mark(function t(e) {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (e || this.containerElement) {
                t.next = 2;
                break;
              }

              return t.abrupt("return");

            case 2:
              return e && (this.containerElement = e), this.paypalUiInstance = new qt(), this.paypalUiInstance.render(this.containerElement), t.abrupt("return");

            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return i.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (r = o(h.mark(function t(e, n) {
      var r;
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Kt(e.url, {
                paymentInstrument: {
                  paymentMethod: this.initData.paymentMethod
                }
              });

            case 3:
              return r = t.sent, t.abrupt("return", Mt(r, n));

            case 7:
              return t.prev = 7, t.t0 = t["catch"](0), t.abrupt("return", Mt(t.t0));

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, this, [[0, 7]]);
    })), function (t, e) {
      return r.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (n = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement.innerHTML = "", this.paypalUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (e = o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}(),
    Xt = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];

function $t(t, e) {
  var n = "\n    <div style='width: 780px;padding: 153px 24px 24px;box-sizing:border-box;background: url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjExMyIgdmlld0JveD0iMCAwIDIwMCAxMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNDggOTZINTFDNDcuNjg2MyA5NiA0NSA5My4zMTM3IDQ1IDkwVjI0QzQ1IDIwLjY4NjMgNDcuNjg2MyAxOCA1MSAxOEgxNDhDMTUxLjMxNCAxOCAxNTQgMjAuNjg2MyAxNTQgMjRWOTBDMTU0IDkzLjMxMzcgMTUxLjMxNCA5NiAxNDggOTZaIiBzdHJva2U9IiNEOEQ4RDgiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTI2IDUxLjgwOVY4MC43MzM3QzEyNiA4MC44NDgxIDEyNi4wMDIgODAuOTU5NiAxMjYuMDEzIDgxLjA3MzVDMTI2LjE2MiA4Mi41OTIxIDEyNy44ODMgOTQuMDMwNiAxNDYuMzM2IDEwMC4zMzdDMTQ3LjY4IDEwMC43OTYgMTQ5LjEyNyAxMDAuODMyIDE1MC40NjkgMTAwLjM2N0MxNTUuMjkxIDk4LjY5NzYgMTY3LjEwMyA5My40NDE1IDE2OS45OTggODEuMjk4MkMxNzAuMDAzIDgxLjI2NjcgMTY5Ljk5OCA1MS44MDg3IDE2OS45OTggNTEuODA4N0wxNTAuMTExIDQ3LjM4MDJDMTQ4Ljk4NiA0Ny4xMjk3IDE0Ny44MiA0Ny4xMjUyIDE0Ni42OTMgNDcuMzY3MUwxMjYgNTEuODA5WiIgZmlsbD0iI0Y4RkFGQiIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQxIDY4LjM4NDZDMTQxIDY0IDE0NC4xMzQgNjEgMTQ4IDYxQzE1MS44NjYgNjEgMTU1IDY0IDE1NSA2OC4zODQ2QzE1NSA3Mi40NjMgMTUxLjA2MiA3NS4zMDc3IDE0OCA3NS43NjkyQzE0OCA3Ny4xNTM4IDE0OCA3OSAxNDggNzkiIHN0cm9rZT0iI0Q4RDhEOCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTQ4IiBjeT0iODYiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTQ3IDMzSDE1MyIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiLz4KPGNpcmNsZSBjeD0iMTMwIiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTM4IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTQ2IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPC9zdmc+Cg==", ") no-repeat center 40px/200px 113px;'>\n      <p style='margin: 0;padding: 0;text-align: center;font-size: 12px;line-height: 16px;color: #1e1e1e;opacity: 0.8'>").concat({
    de: "Entschuldigung, Ihr  Browser mit der aktuellen Benutzeroberfläche nicht kompatibel ist. Wir  empfehlen IE11/Chrome für eine optimale Verwendung.",
    en: "Sorry, this browser  is not supported, we suggest you to change to IE11/Chrome or other browsers  to try again",
    es: "Perdón, no es  compatible con el navegador actual, es recomendable intentar de nuevo con los  navegadores de IE11/Chrome, etc.",
    fr: "Désolé, le navigateur  actuel n’est pas compatible, il est recommandé de remplacer IE11 / Chrome et  d’autres navigateurs pour réessayer",
    ja: "申し訳ありませんが、このブラウザは現在サポートされていません  。IE11/ Chromeまたは他のブラウザに変更して再試行することをお勧めします",
    ru: "Извините, текущий  браузер несовместим, рекомендуется заменить на IE11 / Chrome или другие  браузеры для повторной попытки.",
    th: "ขออภัยค่ะ  เบราว์เซอร์ปัจจุบันไม่รองรับ ขอแนะนำให้เปลี่ยนเป็นเบราว์เซอร์ IE11/Chrome  เพื่อลองใหม่อีกครั้งค่ะ",
    "zh-CN": "抱歉，当前浏览器不兼容，建议更换IE11/Chrome等浏览器重试",
    "zh-TW": "抱歉，當前瀏覽器不相容，建議更換IE11/Chrome等瀏覽器重試"
  }[e], "</p>\n    </div>\n  ");
  t.innerHTML = n;
}

function te(t) {
  return t && !/^https?/.test(t) ? "https://".concat(t) : t;
}

function ee(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ne(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ee(Object(n), !0).forEach(function (e) {
      u(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ee(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var re = function () {
  function e(n, r) {
    var i,
        c,
        s,
        l = this;
    a(this, e), u(this, "check", function () {
      if (l.isNotSupportBrowser) throw new Error("no support browser");
    }), u(this, "init", o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return pt(l.reportData, "init_start"), l.element && l.renderWidget(l.element), l.check(), l.renderCheck(), l.paySession = new lt(l.initData.host).init().then(function (t) {
                return pt(l.reportData, "init_end", t.sessionId), l.sessionId = t.sessionId, ne(ne({}, t), {}, {
                  paymentMethod: l.initData.paymentMethod,
                  channelId: l.initData.channelId
                });
              }), t.next = 7, l;

            case 7:
              return t.abrupt("return", t.sent);

            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), u(this, "renderWidget", function () {
      var t = o(h.mark(function t(e) {
        var n, r, i, o, a;
        return h.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (pt(l.reportData, "render_start", l.sessionId), n = e, "string" == typeof e && (n = document.querySelector(e), console.assert(n, "请检查元素 ".concat(e, " 是否存在, 注意: id 需要加 '#' 前缀, class 需要加 '.' 前缀"))), !l.isNotSupportBrowser) {
                  t.next = 8;
                  break;
                }

                return r = l.initData.language, o = "string" == typeof (i = void 0 === r ? "en" : r) ? i : (null == i ? void 0 : i.extend) || "en", $t(n, o), t.abrupt("return", null);

              case 8:
                return a = l.metaData.paymentMethod, t.next = 11, l.channel.needRenderWidget();

              case 11:
                if (!t.sent) {
                  t.next = 18;
                  break;
                }

                return t.next = 15, l.channel.render(n);

              case 15:
                pt(l.reportData, "render_end", l.sessionId), t.next = 19;
                break;

              case 18:
                console.warn('支付方式 "'.concat(a, '" 不需要渲染控件'));

              case 19:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }()), u(this, "getPaySession", o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return pt(l.reportData, "get_paySession", l.sessionId), t.t0 = JSON, t.next = 4, l.paySession;

            case 4:
              return t.t1 = t.sent, t.abrupt("return", t.t0.stringify.call(t.t0, t.t1));

            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), u(this, "needRenderWidget", o(h.mark(function t() {
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (!l.isNotSupportBrowser) {
                t.next = 2;
                break;
              }

              return t.abrupt("return", !1);

            case 2:
              return t.next = 4, l.channel.needRenderWidget();

            case 4:
              return t.abrupt("return", t.sent);

            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), u(this, "validate", o(h.mark(function t() {
      var e;
      return h.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return pt(l.reportData, "validate_start", l.sessionId), t.next = 3, l.channel.validate();

            case 3:
              return e = t.sent, pt(l.reportData, "validate_end", l.sessionId), t.abrupt("return", e);

            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), u(this, "pay", function () {
      var t = o(h.mark(function t(e, n) {
        var r, i;
        return h.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return pt(l.reportData, "call_pay_start", l.sessionId), t.next = 3, l.paySession;

              case 3:
                return r = t.sent, t.next = 6, l.channel.pay(e, ne(ne({}, n), {}, {
                  beforeRedirect: function () {
                    var t = o(h.mark(function t(e) {
                      return h.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              if (pt(l.reportData, "call_pay_end_with_redirect", l.sessionId), null == n || !n.beforeRedirect) {
                                t.next = 5;
                                break;
                              }

                              return t.next = 4, n.beforeRedirect(e);

                            case 4:
                              return t.abrupt("return", t.sent);

                            case 5:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }(),
                  sessionId: r.sessionId
                }));

              case 6:
                return i = t.sent, pt(l.reportData, "call_pay_end", l.sessionId), t.abrupt("return", i);

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }()), u(this, "destroy", function () {
      pt(l.reportData, "destroy_SDK", l.sessionId), l.channel.destroy();
    }), H.setTag("host", n.host || "https://cashiers.myshopline.com"), this.reportData = ne(ne({}, n), {}, {
      pvId: t
    }), pt(this.reportData, "constructor_start"), n.channelId = void 0 !== n.channelId ? n.channelId : "SLPayments", n.host = te(n.host), this.initData = Object.freeze(n), this.isNotSupportBrowser = (i = navigator.userAgent, Xt.every(function (t) {
      var e = t.exec(i);
      return !!(e && Number(e[1]) < 11);
    })), this.check(), this.metaData = Object.freeze((c = this.initData, s = {}, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"].forEach(function (t) {
      void 0 !== c.hasOwnProperty(t) && (s[t] = c[t]);
    }), s)), this.element = r;
    var d = this.metaData.paymentMethod;
    if (d === p.BankTransfer) this.channel = new Zt();else if (d === p.Paypal) this.channel = new Jt(this.initData);else {
      if (d !== p.CreditCard) throw new Error("".concat(d, " is not support!"));
      this.channel = new Vt(this.initData);
    }
    pt(this.reportData, "constructor_end");
  }

  return s(e, [{
    key: "renderCheck",
    value: function value() {
      var t = this,
          e = this.initData,
          n = e.merchantId,
          r = e.countryCode,
          i = e.paymentMethod,
          o = e.currency,
          a = e.channelId,
          c = e.host;
      J.post("".concat(c || "https://cashiers.myshopline.com", "/v1/api/cashier/init"), {
        merchantId: n,
        countryCode: r,
        paymentMethod: i,
        currency: o,
        channelId: a
      }).then(function (e) {
        var n = e.data.brands || [];
        t.channel.setSupportCardBrands && t.channel.setSupportCardBrands(n);
      });
    }
  }]), e;
}(),
    ie = function ie(t) {
  return t = te(t), pt({}, "init_risk_start"), new lt(t).init().then(function (t) {
    pt({}, "init_risk_end", t.sessionId);
  });
};

function oe(t, e) {
  var _n3 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

  if (!_n3) {
    if (Array.isArray(t) || (_n3 = function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return ae(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(t);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ae(t, e);
    }(t)) || e && t && "number" == typeof t.length) {
      _n3 && (t = _n3);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function e(t) {
          throw t;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      _n3 = _n3.call(t);
    },
    n: function n() {
      var t = _n3.next();

      return a = t.done, t;
    },
    e: function e(t) {
      c = !0, o = t;
    },
    f: function f() {
      try {
        a || null == _n3["return"] || _n3["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function ae(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function ce() {
  if (!(this instanceof ce)) throw new Error("构造函数请使用new");

  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
    e[n] = arguments[n];
  }

  var i,
      o = r(re, e),
      a = oe(Object.getOwnPropertyNames(o));

  try {
    var c = function c() {
      var t = i.value,
          e = o[t];
      "function" == typeof e && (o[t] = function () {
        try {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = e.apply(this, r);
          return o instanceof Promise ? o["catch"](function (e) {
            throw H.report(e), new Error("".concat(t, " err"));
          }) : o;
        } catch (e) {
          throw H.report(e), new Error("".concat(t, " error"));
        }
      });
    };

    for (a.s(); !(i = a.n()).done;) {
      c();
    }
  } catch (t) {
    a.e(t);
  } finally {
    a.f();
  }

  return o;
}

function se() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
    e[n] = arguments[n];
  }

  ie.apply(this, e)["catch"](function (t) {
    H.report(t);
  });
}

export { ce as Payment, se as initRisk, G as version };